// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap, no-negated-condition */
import Cookies from "js-cookie" // debug cookies
import { Record, Map, fromJS } from "immutable"
import { Platform } from "@kiwicom/nitro/lib/services/platform/consts"

import RESULTS_VIEW_TYPES from "../consts/resultViewTypes"
import constants from "../consts/config"

const Options = Record({
  affiliateThisSession: "", // query based
  affiliate: "", // cookies based
  affiliateConfig: null,
  apiUrl: constants.apiUrl,
  metaApiUrl: constants.metaApiUrl,
  umbrellaUrl: constants.umbrellaUrl,
  authApiUrl: constants.authApiUrl,
  bookingApiUrl: constants.bookingApiUrl,
  prebookingApiUrl: constants.prebookingApiUrl,
  piciApiUrl: constants.piciApiUrl,
  mmbPiciApiUrl: constants.mmbPiciApiUrl,
  mmbApiUrl: constants.bookingApiUrl,
  priceAlertUrl: constants.priceAlertUrl,
  locationsApiUrl: constants.locationsApiUrl,
  graphqlApiUrl: constants.graphqlApiUrl,
  ancillariesApiUrl: constants.ancillariesApiUrl,
  accountGraphqlApi: constants.accountGraphqlApi,
  mmb2BasePath: constants.mmb2BasePath,
  translationUrl: null,
  preferredResultsView: RESULTS_VIEW_TYPES.AUTO, // TODO move to separate reducer
  country: "",
  previousCurrency: null,
  currency: "eur",
  geo: Map(),
  ui: "web" as Platform,
  branding: null,
  language: "en",
  browserLanguage: null,
  showTranslationKeys: false,
  showSmartFillOptions: false,
  enableHiddenFeatures: false,
  showConsoleLogs: false,
  debugUmbrella: false,
  showMobileAd: false,
  disableServices: "",
  enableServices: "",
  isRootPage: false,
  // TODO refactor to have it only in wowair module
  wowairRequestDate: false,
  wowairRequestDirection: "",
  isAutomatedTest: false,
  isIframeSubdomain: false,
  userId: "",
  customerVerified: false,
  fakeCuckoo: false,
  apiKey: "",
  bookedAt: null,
  bookedAtScrooge: null,
  cookieSettings: "",
})

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function optionsFromPlainJS(plain: any) {
  const lat = parseFloat(plain.geo.lat)
  const lng = parseFloat(plain.geo.lng)

  return new Options({
    ...plain,
    debugUmbrella: Cookies.get("debugUmbrella") === "true" || false,
    showConsoleLogs: Cookies.get("showConsoleLogs") === "true" || false,
    fakeCuckoo: Cookies.get("debug_fakeCuckoo") === "true" || false,
    branding: fromJS(plain.branding),
    geo: fromJS(plain.geo).merge({
      lat: !isNaN(lat) ? lat : plain.geo.lat,
      lng: !isNaN(lng) ? lng : plain.geo.lng,
    }),
  })
}

export default Options
